//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../assets/styles/colors';
import InlineLoader from '../../../elements/LoadingSpinner/InlineLoader';

const useStyles = makeStyles(() => ({
  overlayLoader: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    left: 0,
    zIndex: 1,
    flexDirection: 'column',

    gap: '1rem',
  },
  overlayCaption: {
    fontSize: '0.875rem',
    color: colors.grey900,
    fontWeight: 600,
  },
  caption: {
    fontSize: '.875rem',
    color: colors.grey800,
  },
}));

type Props = {
  visible: boolean,
  message: string,
  submessage?: string,
};

export default function TrainingOverlay({visible, message, submessage}: Props) {
  const classes = useStyles();

  if (!visible) return null;

  return (
    <div className={classes.overlayLoader}>
      <InlineLoader loading size={40} />
      <Typography variant="caption" className={classes.overlayCaption}>
        {message}
      </Typography>
      {submessage && (
        <Typography variant="caption" className={classes.caption}>
          {submessage}
        </Typography>
      )}
    </div>
  );
}
